import React, { useState } from "react";
import { Button } from "reactstrap";
import Switch from "react-switch";
import { switchState, deleteQuestion } from "./Axios";

const formatAnswerType = (type) => {
  switch (type) {
    case "text":
      return "Texto";
    case "textarea":
      return "Area Texto";
    case "number":
      return "Número";
    case "boolean":
      return "Sí / No";
    default:
      return "-";
  }
};

const ProfileCustomQuestionHit = ({
                                    index,
                                    question,
                                    showNotification,
                                    removeQuestion,
                                    updateHit
                                  }) => {
  const [questionData, setQuestionData] = useState(question);
  const [checked, setChecked] = useState(question.aasm_state === "active");

  const handleSwitchState = () => {
    let switch_state = checked ? "deactivate" : "activate";
    const formData = new FormData();
    formData.append("switch_state", switch_state);

    switchState(question.id, formData, response => {
      if (response.status === 200) {
        setChecked(!checked);
        setQuestionData(response.data);
        updateHit(response.data);
        showNotification("Genial", "Estado cambiado con éxito!", "success");
      } else {
        showNotification("Ops", "Error al cambiar de estado!", "danger");
      }
    });
  };

  const handleDelete = () => {
    if (window.confirm("¿Estás seguro de que quieres eliminar esta pregunta?")) {
      deleteQuestion(question.id, response => {
        if (response.status === 200) {
          showNotification("Eliminado", "Pregunta eliminada con éxito", "success");
          removeQuestion(question.id);
        } else {
          showNotification("Error", "No se pudo eliminar la pregunta", "danger");
        }
      });
    }
  };

  return (
    <tr>
      <td>{index}</td>
      <td>{questionData.name}</td>
      <td>{formatAnswerType(questionData.answer_type)}</td>
      <td>
        <Switch
          checked={checked}
          onChange={handleSwitchState}
          onColor="#00c851"
          offColor="#ff3547"
        />
      </td>
      <td>
        <Button color="danger" size="sm" onClick={handleDelete}>
          <i className="fas fa-trash"></i>
        </Button>
      </td>
    </tr>
  );
};

export default ProfileCustomQuestionHit;